import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import {
    piIconCircleCheckBold,
    piIconClosePanel,
    piIconInfo,
    piIconLink,
    piIconPencil,
    piIconTrash,
    piIconVerticalDotsBold
} from '@predictiveindex/pi-client-icons';
import {
    GridModule,
    TapestryButtonModule,
    TapestryCheckboxModule,
    TapestryChipSelectComponent,
    TapestryDropdownModule,
    TapestryExpansionPanelModule,
    TapestryIconButtonModule,
    TapestryIconModule,
    TapestryIconRegistryService,
    TapestryInlineMessageBoxModule,
    TapestryMultiAutocompleteModule,
    TapestrySearchModule,
    TapestrySelectModule,
    TapestryTableModule,
    TapestryTextAreaModule,
    TapestryTextModule,
    TapestryTooltipModule,
    TapestryTypeaheadModule
} from '@predictiveindex/tapestry';
import { AgGridAngular } from 'ag-grid-angular';
import { TranslationsModule } from '../../../translations/translations.module';
import { DirectivesModule } from '../../Directives';
import { DemoUserDataDisplayByIdPipe } from './demo-user-display-by-id.pipe';
import { OiNotificationsTableComponent } from './open-invitation/components/oi-notifications-table/oi-notifications-table.component';
import { OIActionMenuRendererComponent } from './open-invitation/oi-action-menu-renderer.component';
import { OIOpenFolderRendererComponent } from './open-invitation/oi-open-folder-renderer.component';
import { OpenInvitationPeekComponent } from './open-invitation/open-invitation.component';
import { ProspectDemosComponent } from './prospect-demos/prospect-demos.component';
import { SellerToolsBaseComponent } from './seller-tools-base.component';
import { WorkshopAccountsComponent } from './workshop-accounts/workshop-accounts.component';

const components = [
    OpenInvitationPeekComponent,
    OIActionMenuRendererComponent,
    OIOpenFolderRendererComponent,
    ProspectDemosComponent,
    SellerToolsBaseComponent,
    WorkshopAccountsComponent
];

@NgModule({
    declarations: [...components],
    exports: [...components],
    imports: [
        DemoUserDataDisplayByIdPipe,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TapestryTableModule,
        TapestryButtonModule,
        TapestryTextModule,
        TapestryTextAreaModule,
        TapestryCheckboxModule,
        TapestryTypeaheadModule,
        TapestrySelectModule,
        TapestryIconModule,
        TapestryExpansionPanelModule,
        TranslationsModule,
        GridModule,
        TapestryDropdownModule,
        ClipboardModule,
        TapestryIconButtonModule,
        MatDialogModule,
        MatMenuModule,
        MatListModule,
        TapestryTooltipModule,
        OiNotificationsTableComponent,
        TapestryChipSelectComponent,
        TapestryMultiAutocompleteModule,
        TapestryInlineMessageBoxModule,
        MatTabsModule,
        MatDividerModule,
        DirectivesModule,
        AgGridAngular,
        TapestrySearchModule
    ]
})
export class SellerToolsPeekModule {
    constructor(private iconRegistry: TapestryIconRegistryService) {
        this.iconRegistry.registerIcons([
            piIconTrash,
            piIconPencil,
            piIconLink,
            piIconVerticalDotsBold,
            piIconCircleCheckBold,
            piIconInfo,
            piIconClosePanel
        ]);
    }
}
